(function () {
  'use strict';

  function setupWorkshopView() {
    var root = document.querySelector('[data-esh-workshop]');
    if (!root) return;
    var view = new URLSearchParams(window.location.search).get('vis') || 'hjelp';
    if (view !== 'hjelp' && view !== 'lokasjon' && view !== 'priser') view = 'hjelp';
    document.documentElement.setAttribute('data-esh-vis', view);
    var titles = {
      hjelp: 'Hva trenger du hjelp med?',
      lokasjon: 'Hvor finner du oss?',
      priser: 'Priser'
    };
    document.title = titles[view] + ' – Elvebyen Sykkel & Hage';
  }

  function setupWorkshopFilters() {
    var root = document.querySelector('[data-esh-workshop]');
    if (!root || root.getAttribute('data-esh-ds-ready') === 'true') return;
    root.setAttribute('data-esh-ds-ready', 'true');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-esh-filter]'));
    var services = Array.prototype.slice.call(root.querySelectorAll('[data-esh-service-id]'));
    var symptoms = root.querySelector('#esh-ds-symptoms');
    var symButtons = Array.prototype.slice.call(root.querySelectorAll('[data-esh-sym]'));
    var callout = root.querySelector('[data-esh-callout="del"]');
    var activeFilter = '';
    var activeSym = '';
    var symMap = {
      gir: ['sykkelservice'],
      brems: ['sykkelservice'],
      slange: [],
      lader: ['elsykkelservice'],
      start: ['feilsoking'],
      sesong: ['sykkelservice', 'elsykkelservice', 'gressklipperservice', 'hagemaskinservice', 'snofreserservice']
    };

    function scrollToId(id) {
      var target = document.getElementById(id);
      if (target) target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    function apply() {
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-esh-filter') === activeFilter ? 'true' : 'false');
      });
      if (symptoms) symptoms.hidden = activeFilter !== 'vetikke';
      symButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-esh-sym') === activeSym ? 'true' : 'false');
      });

      var ids = null;
      var showDel = false;
      if (activeFilter === 'vetikke') {
        if (!activeSym) ids = [];
        else if (activeSym === 'slange') showDel = true;
        else ids = symMap[activeSym] || [];
      }

      services.forEach(function (service) {
        var groups = (service.getAttribute('data-esh-service-groups') || '').split(' ');
        var id = service.getAttribute('data-esh-service-id') || '';
        var visible;
        if (showDel) visible = false;
        else if (ids) visible = ids.indexOf(id) !== -1;
        else visible = !activeFilter || groups.indexOf(activeFilter) !== -1;
        service.hidden = !visible;
        var isRec = visible && ids && ids.length === 1 && ids[0] === id;
        service.classList.toggle('is-rec', Boolean(isRec));
        var details = service.querySelector('details');
        if (details) details.open = Boolean(isRec);
      });
      if (callout) callout.classList.toggle('is-rec', showDel);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var next = button.getAttribute('data-esh-filter');
        if (button.getAttribute('aria-pressed') === 'true') next = '';
        activeFilter = next || '';
        activeSym = '';
        apply();
        if (activeFilter === 'vetikke') scrollToId('esh-ds-symptoms');
        else if (activeFilter) scrollToId('priser');
      });
    });
    symButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var next = button.getAttribute('data-esh-sym');
        if (button.getAttribute('aria-pressed') === 'true') next = '';
        activeSym = next || '';
        apply();
        if (activeSym) scrollToId('priser');
      });
    });
    apply();
  }

  function setupContactType() {
    var select = document.getElementById('esh-contact-enquiry-type');
    if (!select || select.getAttribute('data-esh-ds-ready') === 'true') return;
    select.setAttribute('data-esh-ds-ready', 'true');
    var type = new URLSearchParams(window.location.search).get('type');
    if (type === 'business') select.value = 'Bedriftsavtale';
    if (type === 'kommune' || type === 'municipal') select.value = 'Avtale kommune';
    if (type === 'supplier') select.value = 'Leverandør';
  }

  function setupBooking() {
    var select = document.getElementById('esh-booking-service');
    var summary = document.getElementById('esh-booking-summary');
    var summaryText = document.getElementById('esh-booking-summary-text');
    if (!select || select.getAttribute('data-esh-ds-ready') === 'true') return;
    select.setAttribute('data-esh-ds-ready', 'true');

    var aliases = {
      feilsoking: 'feilsoking',
      'feilsøking': 'feilsoking',
      sykkelservice: 'sykkelservice',
      'sykkelservice-standard': 'sykkelservice',
      elsykkelservice: 'elsykkelservice',
      gressklipperservice: 'gressklipperservice',
      hagemaskinservice: 'hagemaskinservice',
      snofreserservice: 'snofreserservice',
      'snøfreserservice': 'snofreserservice',
      sykkel: 'sykkelservice',
      elsykkel: 'elsykkelservice',
      hage: 'hagemaskinservice',
      sno: 'snofreserservice',
      'snø': 'snofreserservice'
    };
    var params = new URLSearchParams(window.location.search);
    var raw = (params.get('tjeneste') || params.get('service') || '').toLowerCase();
    var key = aliases[raw] || raw;
    if (key) {
      Array.prototype.some.call(select.options, function (option, index) {
        if ((option.getAttribute('data-key') || '') !== key) return false;
        select.selectedIndex = index;
        return true;
      });
    }

    function refreshSummary() {
      if (!summary || !summaryText) return;
      var option = select.options[select.selectedIndex];
      summary.hidden = !option || !option.value;
      if (option && option.value) summaryText.textContent = option.text;
    }
    refreshSummary();
    select.addEventListener('change', refreshSummary);

    var date = document.querySelector('input[name="contact[preferred_date]"]');
    if (date) {
      date.addEventListener('input', function () {
        var digits = date.value.replace(/[^0-9]/g, '').slice(0, 8);
        if (digits.length >= 5) date.value = digits.slice(0, 2) + '.' + digits.slice(2, 4) + '.' + digits.slice(4);
        else if (digits.length >= 3) date.value = digits.slice(0, 2) + '.' + digits.slice(2);
        else date.value = digits;
      });
    }
  }

  function init() {
    setupWorkshopView();
    setupWorkshopFilters();
    setupContactType();
    setupBooking();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('esh:softnav', init);
})();
